module.exports = "/assets/data/f955e5122104853be329d36e29ce3d26-GU29.data.json";